import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import { _checkCardFaqShow, _checkCardFaqHide } from "../../../utils/ecourse";
import iconArrowUpGrey from "../../../images/icons/icon-arrow-up-grey.svg";
import iconArrowDownGrey from "../../../images/icons/icon-arrow-down-grey.svg";
import "./FaqCard.style";

class FaqCard extends PolymerElement {
  static get template() {
    return html`
      <style include="faq-card-style"></style>
      <div class="container" on-click="onClickContent">
        <template is="dom-if" if="{{_checkCardFaqShow(collapse)}}">
          <div class="row">
            <h3>{{listFaq.title}}</h3>
            <img src="{{iconArrowUpGrey}}" />
          </div>
        </template>
        <template is="dom-if" if="{{_checkCardFaqHide(collapse)}}">
          <div class="row">
            <h3>{{listFaq.title}}</h3>
            <img src="{{iconArrowDownGrey}}" />
          </div>
        </template>
        <div class$="{{collapse}}" inner-h-t-m-l="{{listFaq.content}}"></div>
      </div>
    `;
  }

  static get properties() {
    return {
      listFaq: {
        type: Object,
        value: {},
      },
      iconArrowUpGrey: {
        type: String,
        value: iconArrowUpGrey,
      },
      iconArrowDownGrey: {
        type: String,
        value: iconArrowDownGrey,
      },
      collapse: {
        type: String,
        value: "show",
      },
      _checkCardFaqShow: {
        type: Function,
        value: () => _checkCardFaqShow,
      },
      _checkCardFaqHide: {
        type: Function,
        value: () => _checkCardFaqHide,
      },
    };
  }

  onClickContent() {
    this.collapse = this.collapse == "hide" ? "show" : "hide";
  }
}
customElements.define("faq-card", FaqCard);
